<template>
  <div
    class="brand-logo"
    :class="[`brand-logo--${context}`, { 'is-compact': compact }]"
  >
    <div class="brand-logo__icon" :style="iconStyle">
      <img src="@/assets/img/bg/logo.png" alt="logo" class="brand-logo__img" />
    </div>

    <div v-if="!compact" class="brand-logo__wordmark">
      <div class="brand-logo__title">{{ title }}</div>
      <div v-if="showSubtitle" class="brand-logo__subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandLogo",
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    context: {
      type: String,
      default: "sidebar",
    },
    showSubtitle: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "掌终宝",
    },
    subtitle: {
      type: String,
      default: "SMART SALES AUTOMATION",
    },
  },
  computed: {
    iconStyle() {
      const sizeMap = {
        login: this.compact ? 54 : 116,
        sidebar: this.compact ? 42 : 64,
      };
      const size = sizeMap[this.context] || 42;
      return {
        width: `${size}px`,
        height: `${size}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.brand-logo {
  display: inline-flex;
  align-items: center;
  color: #fff;
  line-height: 1;

  &__icon {
    flex: 0 0 auto;

    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__wordmark {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    min-width: 0;
  }

  &__title {
    font-weight: 700;
    letter-spacing: 0.08em;
    white-space: nowrap;
  }

  &__subtitle {
    margin-top: 4px;
    font-size: 11px;
    letter-spacing: 0.24em;
    white-space: nowrap;
  }
}

.brand-logo--sidebar {
  .brand-logo__title {
    font-size: 24px;
    line-height: 1;
    letter-spacing: 0.06em;
  }

  .brand-logo__subtitle {
    margin-top: 3px;
    font-size: 10px;
    letter-spacing: 0.18em;
    color: rgba(223, 240, 255, 0.86);
  }
}

.brand-logo--login {
  flex-direction: column;
  text-align: center;

  .brand-logo__wordmark {
    margin-top: 18px;
    margin-left: 0;
    align-items: center;
  }

  .brand-logo__title {
    font-size: 40px;
    line-height: 1.08;
    letter-spacing: 0.18em;
    text-shadow: 0 10px 30px rgba(5, 38, 104, 0.25);
  }

  .brand-logo__subtitle {
    margin-top: 10px;
    font-size: 13px;
    color: rgba(231, 243, 255, 0.92);
  }
}

.is-compact {
  justify-content: center;

  .brand-logo__wordmark {
    display: none;
  }
}
</style>
